module.exports = __webpack_public_path__ + "static/media/recommended-label.f15c723b.svg";